import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useAppSelector } from '../../hooks/useAppSelector'
import { Form } from '../../components/Form'
import { PhoneTextBox } from '../../components/TextBox/PhoneTextBox'
import { EmailTextBox } from '../../components/TextBox/EmailTextBox'
import { TextBox } from '../../components/TextBox/TextBox'
import { GenderDropdown } from '../../components/Dropdown/GenderDropdown'
import { TwoColumnFormView } from '../../components/Form/TwoColumnFormView'
import { SectorDropdown } from '../../components/Dropdown/SectorDropdown'
import { FormSectionHeader } from '../../components/Form/FormSectionHeader'
import { SchoolStateDropdown } from '../../components/Dropdown/SchoolStateDropdown'
import { LevelSelectionGroup } from '../../components/SelectionGroup/LevelSelectionGroup'
import { SchoolFeeTextBoxGroup } from '../../components/TextBoxGroup/SchoolFeeTextBoxGroup'
import { SchoolResultTabs } from '../../components/SchoolResultTabs'
import UploadImage from './UploadImage'

const StyledUploadImage = styled(UploadImage)`
  display: inline-block;
  width: 150px;
  height: 150px;
`

interface IEditSchoolFormProps {
  onChange: (ff: object) => void
  formFields: any
  onSubmit: () => void
  isSubmitting: boolean
}

const EditSchoolForm: React.FC<IEditSchoolFormProps> = ({
  onChange,
  formFields,
  onSubmit,
  isSubmitting,
}) => {
  const data = useAppSelector(({ modals }) => modals.data)

  useEffect(() => {
    let mounted = true
    if (mounted && data !== null) {
      if (data.school) {
        onChange({
          logo: data.school.logo,
          name: data.school.name,
          about: data.school.about,
          location: data.school.location,
          level: data.school.level,
          sector: data.school.sector,
          gender: data.school.gender,
          contact: {
            phone: data.school.contact?.phone ?? '',
            email: data.school.contact?.email ?? '',
            website: data.school.contact?.website ?? '',
            facebook: data.school.contact?.facebook ?? '',
            twitter: data.school.contact?.twitter ?? '',
            youtube: data.school.contact?.youtube ?? '',
          },
          fee: data.school.fee,
          results: data.school.results,
        })
        return () => {
          mounted = false
        }
      }
    }
  }, [])

  return (
    <Form onChange={onChange} formFields={formFields} onSubmit={onSubmit}>
      <FormSectionHeader>Logo</FormSectionHeader>
      <StyledUploadImage
        value={formFields.logo}
        onChange={(logo: string) =>
          onChange({
            logo,
            ...formFields,
          })
        }
      />
      <FormSectionHeader>About</FormSectionHeader>
      <TextBox labelText="About" name="about" isMultiLines />
      <FormSectionHeader>General</FormSectionHeader>
      <TextBox disabled={isSubmitting} labelText="Name" name="name" required />
      <GenderDropdown labelText="Gender" name="gender" />
      <LevelSelectionGroup labelText="Level" name="level" />
      <SectorDropdown labelText="Sector" name="sector" />
      <FormSectionHeader>Location</FormSectionHeader>
      <TwoColumnFormView>
        <TextBox labelText="Street" name="location.street" />
        <TextBox labelText="Suburb" name="location.suburb" />
        <TextBox labelText="Postcode" name="location.postcode" />
        <SchoolStateDropdown name="location.state" />
      </TwoColumnFormView>
      <FormSectionHeader>Contact</FormSectionHeader>
      <TwoColumnFormView>
        <PhoneTextBox labelText="Phone" name="contact.phone" />
        <EmailTextBox labelText="Email" name="contact.email" />
        <TextBox labelText="Website" name="contact.website" />
        <TextBox labelText="Facebook" name="contact.facebook" />
        <TextBox labelText="Twitter" name="contact.twitter" />
        <TextBox labelText="Youtube" name="contact.youtube" />
      </TwoColumnFormView>
      <FormSectionHeader>Fees - Local</FormSectionHeader>
      <SchoolFeeTextBoxGroup name="fee.local" />
      <FormSectionHeader>Fees - International</FormSectionHeader>
      <SchoolFeeTextBoxGroup name="fee.international" />
      <FormSectionHeader>Results</FormSectionHeader>
      <SchoolResultTabs name="results" />
    </Form>
  )
}

export default EditSchoolForm
